<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Notification List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.clsnotification {
  display: flex;
  justify-content: flex-start;
}

.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
.option-inner-wrap {
  margin: 0;
  padding: 0;
}
.option-inner-wrap li {
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}
.header-custome span {
  font-size: 15px;
}
.mobile-img {
  height: 600px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.mobile-img img {
  width: 100%;
  object-fit: contain;
  height: 100%;
}
.push-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.push-msg-display-area {
  padding: 15px;
  position: absolute;
  width: 245px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
.push-msg-display-area h3 {
  font-size: 18px;
}
.push-msg-display-area h4 {
  font-size: 16px;
}
.blank-attendee {
  height: 732px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.entity-create-sec {
  text-align: center;
}
.entity-setup-buttons button {
  margin: 25px 7px 0;
}
.new-entity-add-button {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
.emtity-icon {
    height: 160px;
    width: 290px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    overflow: hidden;
}
.emtity-icon img {
    width: 100%;
    height: 100%;
}
.entity-create-desc p {
    width: 480px;
    margin: 0 auto;
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>
        Manage Notification
        <!-- <span>{{
          gridSelectedRows ? "Rows Selected: " + gridSelectedRows : ""
        }}</span> -->
      </h3>
      <div class="knowlg-base-wrap-sec hidden">
        <a href="/pages/knowledge-base/category-attendees/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span>
          Need help with this section?
        </a>
      </div>
    </div>


    <div
      class="vx-card p-6 blank-attendee" v-show="attendeeData.length < 1"
    >
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <img src="../../assets/images/blank-page-images/notification.png"/>
          <!--<feather-icon class="" icon="UsersIcon" />-->
        </div>
        <div class="entity-create-desc">
          <h2>Notification center</h2>
          <p>Send notifications in your virtual event &amp; mobile app to deliver important information to your attendees instantly.</p>
          <div class="entity-setup-buttons">
            
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="$router.push('/event/notification/add')"
              >ADD NEW NOTIFICATION</vs-button
            >
            
          </div>
        </div>
      </div>
    </div>


    <div class="vx-card p-6" v-show="attendeeData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  attendeeData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : attendeeData.length
                }}
                of {{ attendeeData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Attendee-->

        <!-- Exhibitor Add Notification -->
        <vs-popup
          class="holamundo fullscreen"
          title="Add Notification"
          :active.sync="popupActiveAddNotification"
        >
          <div class="vx-row">
            <div class="vx-col md:w-8/12 w-full">
              <form-wizard
                color="rgba(var(--vs-primary), 1)"
                :title="null"
                :subtitle="null"
                :startIndex="activeWizard"
                finishButtonText="Submit & Close"
                @on-complete="saveNotification"
              >
                <tab-content
                  title="What message says"
                  class="mb-5"
                  :before-change="before_save"
                >
                  <div class="vx-row">
                    <div class="vx-col md:w-1/1 w-full">
                      <vs-input
                        label="Notification Title"
                        class="mt-5 w-full"
                        name="NotificationName"
                        v-model="NotificationName"
                        data-vv-as="Notification Name"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('NotificationName')"
                        >{{ errors.first("NotificationName") }}</span
                      >
                    </div>

                    <div class="vx-col md:w-1/1 w-full mt-5">
                      <label>Notification Message</label>
                      <vs-textarea
                        class="w-full"
                        name="NotificationMessage"
                        v-model="NotificationMessage"
                        data-vv-as="Notification Message"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('NotificationMessage')"
                        >{{ errors.first("NotificationMessage") }}</span
                      >
                    </div>
                  </div>
                </tab-content>
                <tab-content
                  title="Who will get it"
                  class="mb-5"
                  :before-change="before_save"
                >
                  <div>
                    <vs-radio
                      v-model="sourceselected"
                      vs-value="allatendees"
                      class="mr-4"
                      vs-name="sourceselected"
                      @change="onSelectButtonChange"
                      >All Attendees</vs-radio
                    >
                    <vs-radio
                      v-model="sourceselected"
                      vs-value="selectedattendees"
                      class="mr-4"
                      vs-name="sourceselected"
                      @change="onSelectButtonChange"
                      >Select Attendees</vs-radio
                    >
                    <vs-radio
                      v-model="sourceselected"
                      vs-value="selectedgroups"
                      class="mr-4"
                      vs-name="sourceselected"
                      @change="onSelectButtonChange"
                      >Select Groups</vs-radio
                    >
                  </div>
                  <br />
                  <vx-card v-show="IsAttendeeSelect">
                    <div class="clsnotification">
                      <div>
                        <div class="table-seating-wrapper">
                          <h5>Drag and Drop Attendee(s) to your right</h5>
                          <p>&nbsp;</p>
                        </div>
                        <div class="attendee-searchbox my-5 px-3">
                          <vs-input
                            icon="search"
                            class="inputx w-full searchbox"
                            placeholder="Search Attendee"
                            v-model="attendeeName"
                            @keyup="searchAttendee"
                          />
                        </div>
                        <div
                          class="attendee-list-wrap"
                          style="
                            align-items: flex-start;
                            height: 400px;
                            overflow-y: auto;
                          "
                        >
                          <draggable
                            :list="searchAttendee"
                            :move="checkMoveAttendeeSelected"
                            :group="{
                              name: 'people',
                              pull: 'clone',
                              put: false,
                            }"
                            class="p-2 cursor-move"
                          >
                            <vs-list-item
                              v-for="(listItem, index) in searchAttendee"
                              :key="index"
                              :title="listItem.Name"
                              :subtitle="listItem.Email"
                            >
                            </vs-list-item>
                          </draggable>
                        </div>
                      </div>
                      <div>
                        <div class="single-table-wrap">
                          <div class="attendee-catagory-drop-wrap pl-2">
                            <vs-list class="mt-5">
                              <div class="guest-wrapper">
                                <div class="attendee-table-select-head">
                                  Selected Attendees
                                  <!-- <span>(Max {{ maxGuest }})</span> -->
                                </div>
                                <div class="attendee-guest-list-wrap">
                                  <draggable
                                    :list="selectedAttendee_list"
                                    :move="checkOverflowHost"
                                    :group="{ name: 'people', put: guestPut }"
                                    class="p-2 cursor-move mt-5"
                                  >
                                    <vs-list-item
                                      :class="
                                        attendeesonothertable.includes(
                                          listItem.AttendeeId
                                        )
                                          ? 'bordered'
                                          : 'normal'
                                      "
                                      v-for="(
                                        listItem, index
                                      ) in selectedAttendee_list"
                                      :key="index"
                                      :title="listItem.Name"
                                    >
                                      <span
                                        class="cross-btn"
                                        @click="
                                          removeAttendee(listItem.AttendeeId)
                                        "
                                        ><feather-icon
                                          class="iconsize"
                                          icon="XIcon"
                                      /></span>
                                    </vs-list-item>
                                  </draggable>
                                </div>
                              </div>
                            </vs-list>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vx-card>

                  <!-- <div v-show="ISGroupSelect"> -->
                  <vx-card v-show="ISGroupSelect">
                    <div class="clsnotification">
                      <div>
                        <div class="table-seating-wrapper">
                          <div class="single-table-wrap">
                            <div class="single-table-wrap-top px-3 py-3">
                              <!-- <h5>Select Group</h5> -->
                              <!-- <v-select
                              multiple
                              v-model="modelGroup"
                              :closeOnSelect="false"
                              label="Name"
                              :options="groupList"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            /> -->

                              <h5>Drag and Drop Groups to your right</h5>
                              <p>&nbsp;</p>
                            </div>
                            <div class="attendee-searchbox my-5 px-3">
                              <vs-input
                                icon="search"
                                class="inputx w-full searchbox"
                                placeholder="Search Attendee"
                                v-model="groupname"
                                @keyup="searchGroups"
                              />
                            </div>
                            <div class="attendee-list-select-wrap">
                              <div
                                class="attendee-list-wrap"
                                style="
                                  align-items: flex-start;
                                  height: 400px;
                                  overflow-y: auto;
                                "
                              >
                                <draggable
                                  :list="searchGroups"
                                  :move="checkGroupsMoveSelected"
                                  :group="{
                                    name: 'people',
                                    pull: 'clone',
                                    put: false,
                                  }"
                                  class="p-2 cursor-move"
                                >
                                  <vs-list-item
                                    v-for="(listItem, index) in searchGroups"
                                    :key="index"
                                    :title="listItem.GroupName"
                                  >
                                  </vs-list-item>
                                </draggable>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="single-table-wrap no-border">
                          <div class="attendee-catagory-drop-wrap pl-2">
                            <vs-list class="mt-5">
                              <div class="guest-wrapper">
                                <div class="attendee-table-select-head">
                                  Selected Groups
                                  <!-- <span>(Max {{ maxGuest }})</span> -->
                                </div>
                                <div class="attendee-guest-list-wrap">
                                  <!-- <draggable
                                  :list="guest_list"
                                  :move="checkOverflowHost"
                                  :group="{ name: 'people', put: guestPut }"
                                  class="p-2 cursor-move mt-5"
                                > -->
                                  <draggable
                                    :list="selectedGroup_List"
                                    :move="checkOverflowHost"
                                    :group="{ name: 'people', put: guestPut }"
                                    class="p-2 cursor-move mt-5"
                                  >
                                    <vs-list-item
                                      :class="
                                        groupsonothertable.includes(
                                          listItem.GroupId
                                        )
                                          ? 'bordered'
                                          : 'normal'
                                      "
                                      v-for="(
                                        listItem, index
                                      ) in selectedGroup_List"
                                      :key="index"
                                      :title="listItem.GroupName"
                                    >
                                      <span
                                        class="cross-btn"
                                        @click="removeGroup(listItem.GroupId)"
                                        ><feather-icon
                                          class="iconsize"
                                          icon="XIcon"
                                      /></span>
                                    </vs-list-item>
                                  </draggable>
                                </div>
                              </div>
                            </vs-list>
                          </div>
                          <!-- Save & Reset Button -->
                          <!-- <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="before_save"
                      >Save Changes</vs-button
                    >
                  </div>
                </div>
              </div> -->
                        </div>
                      </div>
                    </div>
                  </vx-card>
                  <!-- </div> -->
                </tab-content>

                <tab-content
                  title="When will get it"
                  class="mb-5"
                  :before-change="before_save"
                >
                  <!-- <div class="mt-3 theme-select-flex-box">
                    <span class="lobbtTagText">Is Scheduled</span>

                    <vs-switch v-model="IsScheduled" @change="onSubButtonChange">
                      <span slot="On" vs-value="2" name="lobbySubButton">On</span>
                      <span slot="Off" vs-value="1" name="lobbySubButton">Off</span>
                    </vs-switch>
                  </div> -->

                  <vs-radio
                    v-model="scheduleSelcted"
                    vs-value="Now"
                    class="mr-4"
                    vs-name="Source-select-notification"
                    @change="onSubButtonChange"
                    >Now</vs-radio
                  >
                  <vs-radio
                    v-model="scheduleSelcted"
                    vs-value="Scheduled"
                    class="mr-4"
                    vs-name="Source-select-notification"
                    @change="onSubButtonChange"
                    >Schedule</vs-radio
                  >

                  <div v-show="IsScheduled" class="vx-col md:w-1/2 w-full mt-5">
                    <label style="padding-right: 10px"
                      >Select Date and Time</label
                    >
                    <flat-pickr
                      :config="configdateTimePickerStart"
                      name="Schedule Date"
                      v-model="ScheduleDate"
                      placeholder="Schedule Date"
                      class="time-pkr"
                      style="padding-right: 10px"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Start Time')"
                      style="padding-right: 10px"
                      >{{ errors.first("Start Time") }}</span
                    >
                    {{ Session_Event_TZ }}
                  </div>
                </tab-content>
              </form-wizard>
            </div>
            <div class="vx-col md:w-4/12 w-full">
              <div class="push-section mb-5">
                <vs-button
                  color="success"
                  size="small"
                  type="filled"
                  class="mr-3"
                  >Send Now</vs-button
                >
                <vs-button color="primary" size="small" type="border"
                  >See Devices</vs-button
                >
              </div>
              <div class="mobile-img">
                <img
                  src="../../assets/images/mobile-notification-img.png"
                  alt="Mobile Image"
                />
                <div class="push-msg-display-area">
                  <h3>{{ NotificationName }}</h3>
                  <!-- <h4>Subtitle</h4> -->
                  <p>{{ NotificationMessage }}</p>
                </div>
              </div>
            </div>
          </div>
          <br />

          <!-- <span>Select Source</span>
          <vs-switch v-model="ISGroupSelect" @change="onSelectButtonChange">
            <span slot="On" vs-value="2" name="groupSelctionButton">On</span>
            <span slot="Off" vs-value="1" name="groupSelctionButton">Off</span>
          </vs-switch> -->

          <br />

          <!-- <div v-show="IsAttendeeSelect">
            <span>Select Attendee(s)</span>

            <v-select
              multiple
              v-model="modelAttendee"
              :closeOnSelect="false"
              label="Name"
              :options="attendessList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div> -->

          <br />

          <!-- <vs-button class="mr-6" v-on:click="before_saveValidate"
            >Submit</vs-button
          >
          <vs-button type="border" color="danger" v-on:click="cloesePop()"
            >Cancel</vs-button
          > -->
          <!-- @click="popupActiveAddNotification = false" -->
        </vs-popup>
        <vs-popup
          class="holamundo"
          title="Import Notification"
          :active.sync="popupUploadActive"
        >
          <div class="import-attendee-wrapper">
            <!-- <div class="template-download">
              <h4>Download the template</h4>
              <a
                color="primary"
                type="filled"
                class="mt-3 btn"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Session.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
                >Download</a
              >
            </div> -->
            <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
            <div class="upload-file mt-5">
              <h4>Upload your file</h4>
              <div class="file-up-section">
                <p>Select XLSX file</p>
                <input
                  type="file"
                  id="notification_file"
                  accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <vs-button
                  color="rgb(76, 139, 246)" type="filled"
                  class="sub-btn"
                  v-on:click="UploadNotification"
                  >Upload</vs-button
                >
              </div>
            </div>
          </div>
        </vs-popup>
        <!-- Exhibitor Category Ends-->
        <!-- <vs-button type="gradient mr-4" v-on:click="CreateNotification()"
          >Create Notification</vs-button> -->

        <vs-button color="rgb(76, 139, 246)" class=" mr-4" type="filled" v-on:click="addRecord()"
          >Compose New</vs-button
        >

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <!-- <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        /> -->
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- <vs-button
          color="primary"
          type="border"
          class="ml-3"
          @click="popupUploadActive = true"
          >Import</vs-button
        > -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="attendeeData"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import draggable from "vuedraggable";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment-timezone";
import axios from "@/axios.js";
import con from "@/firebase/firebaseInit.ts";
// Store Module
import moduleNotificationManagement from "@/store/notification-management/moduleNotificationManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
let GetsendpushApi = con.GetsendpushApi;
let GetGroupPushApi = con.GetGroupPushApi;
let sendpushApiKey = con.sendpushApiKey;
let GetAllTopicPushApi = con.GetAllTopicPushApi;

let clientId = ls.getSessionValueByKey("Session_Client_Id");
let eventId = ls.getSessionValueByKey("Session_Event_Id");
// Cell Renderer
// import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
// import CellRendererStatusReg from "./cell-renderer/CellRendererStatusReg.vue";
// import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import VxBreadcrumbVue from "../../layouts/components/VxBreadcrumb.vue";
// import CellRendererAmountReg from "./cell-renderer/CellRendererAmountReg.vue";
// import CellRendererTransactionIDReg from "./cell-renderer/CellRendererTransactionIDReg.vue";
// import CellRendererSourceReg from "./cell-renderer/CellRendererSourceReg.vue";
// import CellRendererCreatedOnReg from "./cell-renderer/CellRendererCreatedOnReg.vue";
//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");

var eventID = ls.getSessionValueByKey("Session_Event_Id");
var vm;
export default {
  components: {
    FormWizard,
    TabContent,
    draggable,
    AgGridVue,
    vSelect,
    quillEditor,
    flatPickr,

    // Cell Renderer
    // CellRendererLink,
    // CellRendererStatusReg,
    // CellRendererAmountReg,
    // CellRendererTransactionIDReg,
    // CellRendererSourceReg,
    // CellRendererCreatedOnReg,
    // CellRendererVerified,
    CellRendererActions,
  },
  props: {},
  data() {
    return {
      activeWizard: 0,
      popupUploadActive: false,
      scheduleSelcted: "Now",
      pageLoaded: false,
      sourceselected: "allatendees",
      attendee_list: [],
      group_list: [],
      IsAllattendeeSelect: true,
      IsAttendeeSelect: false,
      ISGroupSelect: false,
      IsAllAttendeeSelect: true,
      groupList: [],
      modelGroup: [],
      attendeesonothertable: [],
      groupsonothertable: [],
      hostPut: true,
      guestPut: true,
      maxGuest: "1000",
      attendeeName: "",
      groupname: "",
      attendee_search_list: [],
      group_search_list: [],
      notificationLists: [],
      host_list: [],
      guest_list: [],
      selectedAttendee_list: [],
      selectedGroup_List: [],
      EventData: null,
      modelAttendee: [],
      attendessList: [],
      NotificationName: "",
      NotificationMessage: "",
      ScheduleDate: "",
      IsScheduled: false,
      popupActiveAddNotification: false,
      StartDate: null,
      EndDate: null,
      LSDateTime: null,
      configdateTimePicker: {
        minDate: new Date(),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerStart: {
        minDate: new Date(),
        maxDate: null,
        onChange: function (val) {
          //if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      //gridSelectedRows: 0,
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "ID",
          field: "NotificationId",
          width: 100,
          filter: false,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          hide: true,
          pinned: "left",
        },
        {
          headerName: "Title",
          field: "NotificationTitle",
          filter: true,
          checkboxSelection: true,
          width: 230,
          pinned: "left",
        },
        {
          headerName: "Message",
          field: "NotificationMessage",
          filter: true,
          width: 350,
        },
        {
          headerName: "Attendee/Group Count",
          field: "attendeeCount",
          filter: false,
          width: 220,
        },

        {
          headerName: "Sent On",
          field: "scheduleDateTime",
          cellRenderer: (data) => {
            return data.value
              ? vm.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: false,
          width: 215,
        },
        {
          headerName: "Created On",
          field: "CreatedDate",
          cellRenderer: (data) => {
            return data.value
              ? vm.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
          width: 215,
        },
        {
          headerName: "Last Modified",
          field: "LastModifiedDate",
          cellRenderer: (data) => {
            return data.value
              ? vm.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
          width: 215,
        },
        {
          headerName: "status",
          field: "status",
          filter: false,
          width: 150,
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.NotificationId };
          },
        },
      ],

      // Cell Renderer Components
      components: {
        // CellRendererLink,
        // CellRendererStatusReg,
        // CellRendererAmountReg,
        // CellRendererTransactionIDReg,
        // CellRendererSourceReg,
        // CellRendererCreatedOnReg,
        // CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {},
  computed: {
    searchGroups() {
      debugger;
      let groupname = vm.groupname.trim().toLowerCase();

      if (groupname) {
        return vm.group_search_list.filter((row) => {
          if (row.GroupName !== undefined && row.GroupId !== undefined) {
            return (
              row.GroupName.toLowerCase().includes(groupname) ||
              row.GroupId.toLowerCase().includes(groupname)
            );
          }
        });
      } else {
        return vm.group_search_list;
      }
    },
    searchAttendee() {
      debugger;
      let attendeeName = vm.attendeeName.trim().toLowerCase();

      if (attendeeName) {
        return vm.attendee_search_list.filter((row) => {
          if (
            row.FirstName !== undefined &&
            row.LastName !== undefined &&
            row.Email !== undefined
          ) {
            return (
              row.FirstName.toLowerCase().includes(attendeeName) ||
              row.LastName.toLowerCase().includes(attendeeName) ||
              row.Email.toLowerCase().includes(attendeeName)
            );
          }
        });

        // vm.attendee_search_list.filter((row) => {
        //   if (
        //     row.FirstName !== undefined &&
        //     row.LastName !== undefined &&
        //     row.Email !== undefined
        //   ) {
        //     if (
        //       row.FirstName.toLowerCase().includes(attendeeName) ||
        //       row.LastName.toLowerCase().includes(attendeeName) ||
        //       row.Email.toLowerCase().includes(attendeeName)
        //     ) {
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   }
        // });
      } else {
        return vm.attendee_search_list; //this.attendee_search_list = this.attendee_list;
      }
    },

    attendeeData() {
      return vm.notificationLists;
      //return this.$store.state.attendeeManagement.attendees;
    },

    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        //vm.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    addRecord() {
      this.$router.push("/event/notification/add").catch(() => {});
    },
    UploadNotification: function () {
      debugger;
      var files = document.getElementById("notification_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "notification");
    },
    cloesePop() {
      vm.popupActiveAddNotification = false;
      vm.host_list = [];
      vm.guest_list = [];
      vm.selectedAttendee_list = [];
      vm.host_list = [];
      vm.guest_list = [];
      vm.selectedGroup_List = [];
    },
    checkOverflowHost(evt) {
      //console.log(this.host_list.length)
      // return this.host_list.length == 0 ? true : false;
      true;
    },

    checkMoveAttendeeSelected: function (evt) {
      // console.log(this.host_list.length);
      let ID = evt.draggedContext.element.AttendeeId;
      let Name = evt.draggedContext.element.Name;
      let found = this.host_list.some((el) => el.AttendeeId === ID);
      let foundl = this.selectedAttendee_list.some(
        (el) => el.AttendeeId === ID
      );
      if (found || foundl) {
        return false;
      } else {
        // this.checkUserOnOtherTable(ID, Name);
        return true;
      }
      //true;
    },
    checkGroupsMoveSelected: function (evt) {
      console.log(this.host_list.length);
      let ID = evt.draggedContext.element.GroupId;
      let Name = evt.draggedContext.element.GroupName;
      let found = this.host_list.some((el) => el.GroupId === ID);
      let foundl = vm.selectedGroup_List.some((el) => el.GroupId === ID);
      if (found || foundl) {
        return false;
      } else {
        // this.checkUserOnOtherTable(ID, Name);
        return true;
      }
      //true;
    },
    fetch_attendees() {
    	this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/fetchAttendees", null)
        .then((res) => {
          this.attendee_search_list = this.attendee_list = res.filter((row) => {
          	this.pageLoaded = true;
        	this.$vs.loading.close();
            return row.IsPublished;
          });
          // this.attendee_list = this.attendee_list.sort((a, b) => {
          //   let fa = a.FirstName.toLowerCase();
          //   let fb = b.FirstName.toLowerCase();
          //   if (fa < fb) {
          //     return -1;
          //   }
          //   if (fa > fb) {
          //     return 1;
          //   }
          //   return 0;
          // });
        });
    },
    fetch_groups() {
      this.$store
        .dispatch("NotificationManagement/fetchgroups", null)
        .then((res) => {
          vm.group_search_list = this.group_list = res.filter((row) => {
            return row.GroupName !== "";
          });
          /*  this.group_list = this.group_list.sort((a, b) => {
            let fa = a.GroupName.toLowerCase();
            let fb = b.GroupName.toLowerCase();
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });*/
        });
    },

    onSubButtonChange: function (context, LobbyType) {
      //debugger

      // if (this.IsScheduled) {
      //   this.IsScheduled = false;
      // } else {
      //   this.IsScheduled = true;
      // }

      if (vm.scheduleSelcted == "Now") {
        this.IsScheduled = false;
      } else if (vm.scheduleSelcted == "Scheduled") {
        this.IsScheduled = true;
      }
    },
    onSelectButtonChange: function (context, LobbyType) {
      debugger;
      //  alert(vm.sourceselected);
      // if (this.ISGroupSelect) {
      //   this.ISGroupSelect = false;
      //   this.IsAttendeeSelect = true;
      // } else {
      //   this.ISGroupSelect = true;
      //   this.IsAttendeeSelect = false;
      // }

      if (vm.sourceselected == "selectedattendees") {
        vm.IsAllAttendeeSelect = false;
        this.ISGroupSelect = false;
        this.IsAttendeeSelect = true;
      } else if (vm.sourceselected == "selectedgroups") {
        vm.IsAllAttendeeSelect = false;
        this.ISGroupSelect = true;
        this.IsAttendeeSelect = false;
      } else if (vm.sourceselected == "allatendees") {
        vm.IsAllAttendeeSelect = true;
        this.ISGroupSelect = false;
        this.IsAttendeeSelect = false;
      }
    },

    CreateNotification: function () {
      this.popupActiveAddNotification = true;
    },
    onSelectionChanged() {
      // let selectedRows = this.gridApi.getSelectedRows();
      // this.gridSelectedRows = selectedRows.length;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },

    exportSelected() {
      let selectedRows;
      debugger;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        var datarowh = [];
        let cellIndex = [];

        datarowh.push("ID");
        datarowh.push("Title");
        datarowh.push("Message");
        datarowh.push("Attendee/Group Count");
        datarowh.push("Scheduled On");
        datarowh.push("Created On");
        datarowh.push("Status");

        //---------------------------
        var datarow = [];
        var timeZone = [];
        timeZone.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"' + timezone + " Time Zone" + '"');

        var TimeZoneHeader = [];
        TimeZoneHeader.push(timeZone);
        debugger;
        // TimeZoneHeader.forEach(function (rowArray) {
        //   let row = rowArray.join(",");
        //   csvContent += row + "\r\n";
        // });

        //---------------------------

        var AttendeeData = [];
        let Header = [];
        let Data = [];

        selectedRows.map((row) => {
          //---------------------------------------------------------
          let datarowv = [];
          var NotificationID = "";
          NotificationID =
            row.NotificationId == undefined ? "" : row.NotificationId;
          datarowv.push(NotificationID);

          var Title = "";
          Title =
            row.NotificationTitle == undefined ? "" : row.NotificationTitle;
          datarowv.push(Title.replace(/[, ]+/g, " ").replace(/#(\S)/g, " "));

          var Message = "";
          Message =
            row.NotificationMessage == undefined ? "" : row.NotificationMessage;
          datarowv.push(Message.replace(/[, ]+/g, " ").replace(/#(\S)/g, " "));

          var attCount = "";
          attCount = row.attendeeCount == undefined ? "" : row.attendeeCount;
          datarowv.push(attCount);

          var ScheduledOn = "";
          if (row.scheduleDateTime != "") {
            ScheduledOn =
              row.scheduleDateTime == undefined
                ? ""
                : vm.SetTimeByZone(
                    new Date(row.scheduleDateTime.seconds * 1000).toUTCString(),
                    Session_Event_TZ
                  );
          }
          datarowv.push(
            ScheduledOn.replace(/[, ]+/g, " ").replace(/#(\S)/g, " ")
          );

          var createdOn = "";
          if (row.CreatedDate != "") {
            createdOn =
              row.CreatedDate == undefined
                ? ""
                : vm.SetTimeByZone(
                    new Date(row.CreatedDate.seconds * 1000).toUTCString(),
                    Session_Event_TZ
                  );
          }
          datarowv.push(
            createdOn.replace(/[, ]+/g, " ").replace(/#(\S)/g, " ")
          );

          var status = "";
          status = row.status == undefined ? "" : row.status;
          datarowv.push(status);

          //---------------------------------------------------------------------------------

          Data.push(datarowv);
        });
        Header.push(datarowh);
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        // AttendeeData = TimeZoneHeader.concat(AttendeeData);
        // debugger;
        AttendeeData = Header.concat(Data);

        TimeZoneHeader.forEach(function (rowArray1) {
          let row1 = rowArray1.join(",");
          csvContent += row1 + "\r\n";
        });

        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        console.log(JSON.stringify(csvContent));
        var filename = "NotificationExport_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one attendee to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    before_save() {
      console.log("validate");
      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then((result) => {
          console.log(result);
          resolve(result);
        });
      });
    },
    before_saveValidate() {
      debugger;
      // vm.$validator.validateAll().then((result) => {
      //   if (result) {
      //     // if form have no errors
      this.saveNotification();
      //   }
      // });
    },
    fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          vm.EventData = res.data;
        });
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      debugger;
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    showNotification: function () {
      var dt = this.modelAttendee;
      debugger;
      console.log("selected attendees :-" + dt);

      debugger;
      var cn = ls.getSessionEventCollectionName();

      debugger;

      con.eventDB
        .collection(cn)
        .doc("NotificationList")
        .collection("Notifications")
        .orderBy("LastModifiedDate", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var docObj = doc.data();
            docObj.attendeeCount = 0;
            if (docObj.Attendees) {
              docObj.attendeeCount = docObj.Attendees.length + " Attendee(s)";
            } else if (docObj.Groups) {
              docObj.attendeeCount = docObj.Groups.length + " Group(s)";
            } else {
              docObj.attendeeCount = "All Attendees";
            }
            docObj.NotificationId = doc.id;
            docObj.NotificationId = doc.id;
            vm.notificationLists.push(docObj);
          });
        });

      //------------------------------------------------------------------------------
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    saveNotification: function () {
      debugger;
      var cn = ls.getSessionEventCollectionName();

      if (vm.NotificationName == "" || vm.NotificationMessage == "") {
        vm.$vs.notify({
          color: "warning",
          position: "top-center",
          title: "Notification",
          text: "Please fill up notification title and message!",
        });
      } else {
        if (vm.IsAttendeeSelect) {
          vm.$vs.loading();
          // console.log("host_list" + this.host_list);
          //  console.log("selectedAttendee_list" + this.selectedAttendee_list);

          //-----old code - DO NOT REMOVE-------------------------------------------------------------------

          /* var dt = this.modelAttendee;
        debugger;
        console.log("selected attendees :-" + dt);

        debugger;
        var cn = ls.getSessionEventCollectionName();

        var localAttendees = [];
        dt.forEach(function (rowArray) {
          localAttendees.push({
            AttendeeID: rowArray.AttendeeId,
            Email: rowArray.Email,
            Name: rowArray.Name,
          });
        });*/
          //----------------------------------------------------

          // console.log("selected attendees :-" + this.selectedAttendee_list);

          var localAttendees = [];
          this.selectedAttendee_list.forEach(function (rowArray) {
            localAttendees.push({
              AttendeeID: rowArray.AttendeeId,
              Email: rowArray.Email,
              Name: rowArray.Name,
            });
          });

          /* con.eventDB
        .collection(cn)
        .doc("NotificationList")
        .collection("Notifications")
        .doc(rowArray.AttendeeId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            debugger;
            doc.ref
              .update({
                Attendees: localAttendees,
                LastModifiedDate: new Date(),
                IsScheduled: vm.IsScheduled,
                NotificationName: vm.NotificationName,
                NotificationMessage: vm.NotificationMessage,
                scheduleDateTime:
                  vm.ScheduleDate == ""
                    ? ""
                    : vm.GetTimeByZone(vm.ScheduleDate, vm.EventData.TimeZone),
                status: vm.IsScheduled ? "scheduled" : "sent",
              })
              .then(function () {
                console.log("sucess");
                vm.popupActiveAddNotification = false;
              });
          } else {*/

          var cRef = con.eventDB
            .collection(cn)
            .doc("NotificationList")
            .collection("Notifications");
          //.doc(rowArray.AttendeeId);

          var docObj = new Object();
          docObj.Attendees = localAttendees;
          //docObj.AttendeeID = rowArray.AttendeeId;
          docObj.Type = 2;
          docObj.CreatedDate = new Date();
          // docObj.Email = rowArray.Email;
          docObj.LastModifiedDate = new Date();
          docObj.IsScheduled = vm.IsScheduled;
          docObj.NotificationTitle = vm.NotificationName;
          docObj.NotificationMessage = vm.NotificationMessage;
          docObj.scheduleDateTime =
            vm.ScheduleDate == ""
              ? ""
              : vm.GetTimeByZone(vm.ScheduleDate, Session_Event_TZ);
          docObj.status = vm.IsScheduled ? "scheduled" : "sent";
          if (localAttendees.length > 0) {
            cRef
              .add(docObj)
              .then(function (e) {
                console.log("success");
                //console.log(e);

                //-----------------------Notification---------------------------------
                for (var i = 0; i < localAttendees.length; i++) {
                  console.log(localAttendees[i].AttendeeID);
                  var localattendeeId = localAttendees[i].AttendeeID;
                  var subscrRef = con.eventDB
                    .collection(cn)
                    .doc("SubscribersList")
                    .collection("Subscriptions")
                    .doc(localAttendees[i].AttendeeID);

                  subscrRef
                    .get()
                    .then(function (doc) {
                      if (doc.exists) {
                        console.log(doc.data().Devices);
                        //+++++++++++++++++++++ Push start ++++++++++++++++++++++++++++++++++++++++++
                        // var hostUrl = location.host.toLowerCase();
                        // // console.log(hostUrl);
                        // var apiUrl = "";
                        // var xAPIkey = "";
                        // if (hostUrl.includes("localhost")) {
                        //   apiUrl =
                        //     "https://us-central1-uate2monair.cloudfunctions.net/app/api/sendpush";
                        //   xAPIkey = "ws2000rb28082019";
                        // } else {
                        //   if (hostUrl.includes("uat")) {
                        //     apiUrl =
                        //       "https://us-central1-uate2monair.cloudfunctions.net/app/api/sendpush";
                        //     xAPIkey = "ws2000rb28082019";
                        //   } else {
                        //     apiUrl =
                        //       "https://us-central1-uate2monair.cloudfunctions.net/app/api/sendpush";
                        //     xAPIkey = "ws2000rb28082019";
                        //   }
                        // }
                        // console.log(doc.data().Devices.length);
                        debugger;
                        if (vm.IsScheduled) {
                          debugger;
                          vm.$vs.loading.close();
                          vm.selectedAttendee_list = [];
                          vm.attendeeName = "";
                          vm.NotificationName = "";
                          vm.NotificationMessage = "";

                          vm.$vs.notify({
                            color: "success",
                            position: "top-center",
                            title: "Notification",
                            text: "Notification scheduled!",
                          });
                          location.reload();
                        } else {
                          if (doc.data().Devices != undefined) {
                            if (doc.data().Devices.length > 0) {
                              var cntForalert = 0;
                              for (
                                var j = 0;
                                j < doc.data().Devices.length;
                                j++
                              ) {
                                var requestData = {
                                  AttendeeId: localattendeeId,
                                  token: doc.data().Devices[j].DeviceToken,
                                  NotificationId: e.id, // "A3DiDOKny1jDFtEgfiFq",
                                  ClientId: clientId,
                                  EventId: eventId,
                                  title: vm.NotificationName,
                                  msg: vm.NotificationMessage,
                                };
                                sendpushApiKey = "ws2000rb28082019";
                                const headers = {
                                  "Content-Type": "application/json",
                                  apikey: sendpushApiKey,
                                };
                                debugger;
                                // GetsendpushApi =
                                //   "https://us-central1-uate2monair.cloudfunctions.net/app/api/sendpush";

                                console.log(requestData);

                                axios
                                  .post(GetsendpushApi, requestData, {
                                    headers: headers,
                                  })
                                  .then((response) => {
                                    cntForalert++;
                                    vm.$vs.loading.close();
                                    vm.selectedAttendee_list = [];
                                    vm.attendeeName = "";
                                    vm.NotificationName = "";
                                    vm.NotificationMessage = "";
                                    // alert(JSON.stringify(response.data));
                                    //if (response.data.length) {
                                    debugger;

                                    if (
                                      cntForalert == doc.data().Devices.length
                                    ) {
                                      vm.$vs.notify({
                                        color: "success",
                                        position: "top-center",
                                        title: "Notification",
                                        text: "Push sent successfully!",
                                      });
                                      location.reload();
                                    }
                                    //alert("push sent");
                                    //}
                                  })
                                  .catch((error) => {
                                    vm.$vs.loading.close();
                                    alert("push : " + error);
                                  });
                              }
                            } else {
                              vm.$vs.loading.close();
                              // vm.$vs.notify({
                              //   color: "warning",
                              //   position: "top-center",
                              //   title: "Notification",
                              //   text:
                              //     "No subscription found to send notification!",
                              // });
                            }
                          }
                        }
                        //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
                      }
                    })
                    .catch((error) => {
                      vm.$vs.loading.close();
                      alert("subscr : " + error);
                    });
                }

                //--------------------------------------------------------------------

                vm.host_list = [];
                vm.guest_list = [];
                // vm.popupActiveAddNotification = false;
              })
              .catch((error) => {
                vm.$vs.loading.close();
                vm.host_list = [];
                vm.guest_list = [];
                vm.selectedAttendee_list = [];
                //   vm.popupActiveAddNotification = false;
                alert(error);
              });
          } else {
            vm.$vs.loading.close();
            vm.host_list = [];
            vm.guest_list = [];
            vm.selectedAttendee_list = [];
            //  vm.popupActiveAddNotification = false;
          }
          //}
          // })
          // .catch((err) => {
          //   //console.error(err)
          //   this.$vs.loading.close();
          //   vm.popupActiveAddNotification = false;
          // });

          //vm.popupActiveAddNotification = false;
        } else if (vm.ISGroupSelect) {
          vm.$vs.loading();
          debugger;
          var arrLoccalgroup = [];
          var grpids = "";
          for (var i = 0; i < vm.selectedGroup_List.length; i++) {
            // console.log(" groupId :-" + vm.selectedGroup_List[i].GroupId);
            // if (grpids == "") {
            //   grpids = grpids + vm.selectedGroup_List[i].GroupId;
            // } else {
            //   grpids = grpids + "," + vm.selectedGroup_List[i].GroupId;
            // }
            arrLoccalgroup.push(vm.selectedGroup_List[i].GroupId.toString());
          }

          debugger;
          var docObj = new Object();
          docObj.Groups = arrLoccalgroup;
          docObj.Type = 2;
          docObj.CreatedDate = new Date();
          docObj.LastModifiedDate = new Date();
          docObj.IsScheduled = vm.IsScheduled;
          docObj.NotificationTitle = vm.NotificationName;
          docObj.NotificationMessage = vm.NotificationMessage;
          docObj.scheduleDateTime =
            vm.ScheduleDate == ""
              ? ""
              : vm.GetTimeByZone(vm.ScheduleDate, Session_Event_TZ);
          docObj.status = vm.IsScheduled ? "scheduled" : "sent";

          if (arrLoccalgroup.length > 0) {
            var cRef = con.eventDB
              .collection(cn)
              .doc("NotificationList")
              .collection("Notifications");
            debugger;
            cRef
              .add(docObj)
              .then(function (e) {
                console.log("success");

                if (vm.IsScheduled) {
                  debugger;
                  vm.$vs.loading.close();
                  vm.selectedGroup_List = [];
                  vm.groupname = "";
                  vm.NotificationName = "";
                  vm.NotificationMessage = "";

                  vm.$vs.notify({
                    color: "success",
                    position: "top-center",
                    title: "Notification",
                    text: "Notification scheduled!",
                  });
                  location.reload();
                } else {
                  //----------------------- GROUP PUSH ------------------------------------------------------------
                  var requestData = {
                    groupids: arrLoccalgroup,
                    NotificationId: e.id,
                    ClientId: clientId,
                    EventId: eventId,
                    title: vm.NotificationName,
                    msg: vm.NotificationMessage,
                  };
                  sendpushApiKey = "ws2000rb28082019";
                  const headers = {
                    "Content-Type": "application/json",
                    apikey: sendpushApiKey,
                  };
                  debugger;
                  // GetGroupPushApi =
                  //   "https://us-central1-uate2monair.cloudfunctions.net/app/api/sendpush2groups";

                  console.log(JSON.stringify(requestData));
                  debugger;
                  axios
                    .post(GetGroupPushApi, requestData, {
                      headers: headers,
                    })
                    .then((response) => {
                      if (response.status > 0) {
                        debugger;
                        vm.$vs.loading.close();
                        //alert("Group push sentGroup push sent");
                        vm.selectedGroup_List = [];
                        vm.groupname = "";
                        vm.NotificationName = "";
                        vm.NotificationMessage = "";

                        vm.$vs.notify({
                          color: "success",
                          position: "top-center",
                          title: "Notification",
                          text: "Group push sent!",
                        });
                        location.reload();
                      }
                    })
                    .catch((error) => {
                      vm.$vs.loading.close();
                      alert("push : " + error);
                    });

                  //----------------------------------------------------------------------------------------------
                }
                debugger;
                vm.host_list = [];
                vm.guest_list = [];
                vm.selectedGroup_List = [];
                vm.groupname = "";
                vm.NotificationName = "";
                vm.NotificationMessage = "";
                //vm.popupActiveAddNotification = false;
              })
              .catch((error) => {
                debugger;
                vm.$vs.loading.close();
                vm.host_list = [];
                vm.guest_list = [];
                vm.selectedGroup_List = [];
                vm.groupname = "";
                vm.NotificationName = "";
                vm.NotificationMessage = "";
                location.reload();
                vm.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  title: "Notification",
                  text: "Something went wrong!",
                });
                //vm.popupActiveAddNotification = false;
                // alert(error);
              });
          }
          /* for (var i = 0; i < vm.selectedGroup_List.length; i++) {
          console.log(" groupId :-" + vm.selectedGroup_List[i].GroupId);
          debugger;
          var grpRef = con.eventDB
            .collection(cn)
            .doc("GroupList")
            .collection("Groups")
            .doc(vm.selectedGroup_List[i].GroupId)
            .collection("MappedAttendees");
          debugger;
          grpRef
            .get()
            .then((querySnapshot) => {
              var localgroupAttendees = [];
              querySnapshot.forEach((doc) => {
                // console.log(doc.data());
                debugger;
                localgroupAttendees.push({
                  AttendeeID: doc.data().AttendeeId,
                  Email: doc.data().Email,
                  Name: doc.data().FirstName + " " + doc.data().LastName,
                });
              });
              console.log(localgroupAttendees);

              var cRef = con.eventDB
                .collection(cn)
                .doc("NotificationList")
                .collection("Notifications");

              var docObj = new Object();
              docObj.Attendees = localgroupAttendees;
              docObj.CreatedDate = new Date();
              docObj.LastModifiedDate = new Date();
              docObj.IsScheduled = vm.IsScheduled;
              docObj.NotificationName = vm.NotificationName;
              docObj.NotificationMessage = vm.NotificationMessage;
              docObj.scheduleDateTime =
                vm.ScheduleDate == ""
                  ? ""
                  : vm.GetTimeByZone(vm.ScheduleDate, vm.EventData.TimeZone);
              docObj.status = vm.IsScheduled ? "scheduled" : "sent";

              if (localgroupAttendees.length > 0) {
                cRef
                  .add(docObj)
                  .then(function () {
                    console.log("success");
                    this.host_list = [];
                    this.guest_list = [];
                    vm.selectedGroup_List = [];
                    vm.popupActiveAddNotification = false;
                  })
                  .catch((error) => {
                    this.host_list = [];
                    this.guest_list = [];
                    vm.selectedGroup_List = [];
                    vm.popupActiveAddNotification = false;
                    alert(error);
                  });
              } else {
                this.host_list = [];
                this.guest_list = [];
                vm.selectedGroup_List = [];
                vm.popupActiveAddNotification = false;
              }
            })
            .catch((error) => {
              this.host_list = [];
              this.guest_list = [];
              vm.selectedGroup_List = [];
              vm.popupActiveAddNotification = false;
              alert(error);
            });
        }*/
        } else if (vm.IsAllAttendeeSelect) {
          vm.$vs.loading();
          debugger;
          debugger;
          var docObj = new Object();
          docObj.TopicConvention = cn;
          docObj.Type = 1;
          docObj.CreatedDate = new Date();
          docObj.LastModifiedDate = new Date();
          docObj.IsScheduled = vm.IsScheduled;
          docObj.NotificationTitle = vm.NotificationName;
          docObj.NotificationMessage = vm.NotificationMessage;
          docObj.scheduleDateTime =
            vm.ScheduleDate == ""
              ? ""
              : vm.GetTimeByZone(vm.ScheduleDate, Session_Event_TZ);
          docObj.status = vm.IsScheduled ? "scheduled" : "sent";

          var cRef = con.eventDB
            .collection(cn)
            .doc("NotificationList")
            .collection("Notifications");
          debugger;
          cRef.add(docObj).then(function (e) {
            console.log("success");
            //----------------------- TOPIC PUSH [Type=1] ------------------------------------------------------------
            var requestData = {
              NotificationId: e.id,
              ClientId: clientId,
              EventId: eventId,
              title: vm.NotificationName,
              msg: vm.NotificationMessage,
            };
            sendpushApiKey = "ws2000rb28082019";
            const headers = {
              "Content-Type": "application/json",
              apikey: sendpushApiKey,
            };
            debugger;
            // GetGroupPushApi =
            //   "https://us-central1-uate2monair.cloudfunctions.net/app/api/sendpush2groups";

            console.log(JSON.stringify(requestData));
            debugger;
            axios
              .post(GetAllTopicPushApi, requestData, {
                headers: headers,
              })
              .then((response) => {
                if (response.status > 0) {
                  debugger;
                  vm.$vs.loading.close();

                  vm.NotificationName = "";
                  vm.NotificationMessage = "";
                  location.reload();
                  vm.$vs.notify({
                    color: "success",
                    position: "top-center",
                    title: "Notification",
                    text: "Topic push sent successfully!",
                  });
                }
              })
              .catch((error) => {
                vm.$vs.loading.close();
                alert("push : " + error);
              });

            //----------------------------------------------------------------------------------------------
          });
        }

        //------------------------------------------------------------------------------
      }
    },
    removeAttendee(id) {
      let index = this.selectedAttendee_list
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);

      this.selectedAttendee_list.splice(index, 1);
    },
    removeGroup(id) {
      let index = this.selectedGroup_List
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);

      this.selectedGroup_List.splice(index, 1);
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        for (let i = 0; i < res.length; i++) {
          this.attendessList.push({
            AttendeeId: res[i].AttendeeId,
            Company: res[i].Company,
            Designation: res[i].Designation,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone,
            ProfilePictureURL: res[i].ProfilePictureURL,
          });
        }
        console.log(this.attendessList);
      });
    },
    getGroups() {
      this.$store.dispatch("NotificationManagement/fetchgroups").then((res) => {
        for (let i = 0; i < res.length; i++) {
          debugger;
          vm.groupList.push({
            GroupId: res[i].GroupId,
            GroupName: res[i].GroupName,
          });
        }

        console.log(vm.groupList);
      });
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    vm = this;
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!moduleNotificationManagement.isRegistered) {
      this.$store.registerModule(
        "NotificationManagement",
        moduleNotificationManagement
      );
      moduleNotificationManagement.isRegistered = true;
    }
    vm.fetch_event_data();
    this.getGroups();
    this.getAttendees();
    vm.showNotification();
    this.fetch_attendees();
    vm.fetch_groups();
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>